var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiroLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.793 53.2204C71.0145 53.4454 49.6317 76.913 41.9121 99.8187C104.025 142.925 137.381 93.645 125.822 65.0565C115.701 56.6012 105.489 53.1323 95.793 53.2204ZM67.7305 73.1452C67.7305 73.1452 89.7672 73.2106 100.412 73.2106C111.057 73.2106 109.933 83.8211 109.933 83.8211V102.934H100.347C100.347 102.934 100.347 84.9712 100.347 82.917C100.347 79.272 93.6905 78.5067 93.6905 82.917V102.776H84.0712C84.0712 102.776 84.0712 86.7796 84.0712 82.9823C84.0712 79.0932 77.4423 79.1411 77.4423 82.9823V102.776H67.7305V73.1452Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiroLogo);
export default __webpack_public_path__ + "static/media/miroLogo.9a4bf118c0509f1b865ca5011fd2a1dd.svg";
export { ForwardRef as ReactComponent };